export default "__VITE_ASSET__CyCKRa2G__"